import PaymentAmount from "./payment-amount/payment-amount";
import SupporterName from "./supporter-name/supporter-name";

/**
 * Represents a form with payment elements
 * takes care of enhancing accesibility and user experience
 * stripe (payment service) integration happens in a Drupal module
 */
class Payment {
  /**
   * @param {HTMLElement} element - form
   */
  constructor(element) {
    this.element = element;

    this.paymentAmountSelector = ".js-PaymentAmount";
    this.paymentSupporterInputSelectors =
      ".PaymentForm-firstName, .PaymentForm-lastName";

    this._init();
  }

  /**
   * init
   *
   * @private
   */
  _init() {
    this._initPaymentAmountElements();
    this._initSupporterName();
  }

  /**
   * inits payment amount elements
   *
   * @private
   */
  _initPaymentAmountElements() {
    const elements = [
      ...this.element.querySelectorAll(this.paymentAmountSelector),
    ];
    this.paymentAmountElements = elements.map((el) => new PaymentAmount(el));
  }

  /**
   * inits storing of supporter name in local storage
   *
   * @private
   */
  _initSupporterName() {
    const elements = [
      ...document.querySelectorAll(this.paymentSupporterInputSelectors),
    ];
    if (elements.length) {
      this.supporterName = new SupporterName(elements);
    }
  }
}

export default Payment;
